// ----------------------------------------------------------------------------
// Template: Account
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';

// Styles
import './_account.scss';